import Marquee from "react-fast-marquee";

const ITEMS = ["PP ACADEMY", "ENGINEERING", "TRADING", "SCHOOL 1–12", "MBA FINANCE", "EXCELLENCE"];

export const EditorialMarquee = () => (
  <div className="border-y border-white/10 py-8 md:py-12" data-testid="editorial-marquee">
    <Marquee speed={40} gradient={false} pauseOnHover>
      {ITEMS.map((item, i) => (
        <span key={i} className="mx-8 flex items-center gap-16 font-editorial text-4xl italic text-white/20 md:text-6xl">
          {item}
          <span className="font-display text-2xl not-italic text-brand">//</span>
        </span>
      ))}
    </Marquee>
  </div>
);
